import { createContext, useContext, useState, useCallback } from "react";
import NewCustomerDialog from "@/components/customers/NewCustomerDialog";

const Ctx = createContext(null);

export function NewCustomerProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openNew = useCallback(() => setOpen(true), []);
  return (
    <Ctx.Provider value={{ openNew }}>
      {children}
      <NewCustomerDialog open={open} onOpenChange={setOpen} />
    </Ctx.Provider>
  );
}

export const useNewCustomer = () => useContext(Ctx) || { openNew: () => {} };
